import { observer } from "mobx-react-lite";
import { FC, FormEvent, useState } from "react";
import { AuthCardBase } from "@/components/auth/auth-card-base";
import { usePublicAppStore } from "@/store";
import { MDSButton, MDSButtonVariant, MDSTextField, MDSTextFieldVariant } from "@/mds";
import styled from "@emotion/styled";

export interface AuthCardLogInProps {}

export const AuthCardEmailPassword: FC<AuthCardLogInProps> = observer(() => {
  const { publicStore } = usePublicAppStore();

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const handleLogin = async (e: FormEvent) => {
    e.preventDefault;
    await publicStore.auth.authenticateAccountUsingEmailPassword({ email, password });
  };

  const isLoading = publicStore.auth.authenticateAccountUsingEmailPasswordState.isLoading;

  return (
    <AuthCardBase>
      <AuthForm>
        <MDSTextField
          variant={MDSTextFieldVariant.Form}
          type="email"
          placeholder="Email"
          value={email}
          name="Email"
          onChange={value => setEmail(value)}
          isDisabled={isLoading}
          aria-label="Email"
          autoFocus
        />
        <MDSTextField
          variant={MDSTextFieldVariant.Form}
          type="password"
          placeholder="Password"
          name="Password"
          value={password}
          aria-label="Password"
          onChange={value => setPassword(value)}
          isDisabled={isLoading}
        />
        <MDSButton variant={MDSButtonVariant.Contrast} isLoading={isLoading} onClick={handleLogin}>
          Login
        </MDSButton>
      </AuthForm>
    </AuthCardBase>
  );
});

const AuthForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[4]};
  width: 100%;

  // Targets MDSTextField container
  > div {
    width: 100%;
  }
`;
